<template>
	<div v-cloak>
		<h3>
            Detalle
            <span id="badge-personas" class="badge badge-secondary">
                {{personas.length}}
            </span>

            <div class="float-right">
            	<button 
            		type="button" 
            		class="btn btn-sm btn-primary" 
            		v-on:click="getPersonas"
            		v-tooltip="'Actualizar'">
					<i class="material-icons">refresh</i>
				</button>

            	<a 
		    	href="#" 
		    	class="btn btn-sm btn-success" 
		    	v-tooltip="'Agregar persona'"  
		    	v-if="disabled!='true'"
		    	v-on:click.prevent="openModalPersona">
			        <i class="material-icons">add_shopping_cart</i> Agregar
			    </a>
            </div>
            <preloader v-if="personas.length<=0 && loading"></preloader>
        </h3>

		<div class="table-responsive" v-if="personas.length>0">
			<table class="table table-bordered table-striped table-sm">
	            <thead>
	                <tr>
	                    <th>Producto</th>
	                    <th>Tipo Negocio</th>
	                    <th>Traslado Preexistencia</th>
	                    <th>Prima Gastos Médicos</th>
	                    <th>Prima Accidentes Personales</th>
	                    <th>Prima VIDA</th>
	                    <th>Prima DENTAL</th>
	                    <th v-if="false">Total Suma Asegurada</th>
	                    <th>Prima Neta Total</th>
	                    <th style="width: 5%"></th>
	                </tr>
	                <tr v-if="loading">
	                	<th colspan="9" class="p-0">
	                		<preloader></preloader>
	                	</th>
	                </tr>
	            </thead>
	            <tbody>
	            	<tr v-for="persona in personas">
	                    <td>
                            <b>{{persona.producto.DESCRIPCION_PRODUCTO || ''}}</b> - {{persona.producto.grupo.DESCRIPCION_GRUPO || ''}} - {{persona.producto.subgrupo.DESCRIPCION_SUBGRUPO || ''}}</td>
                        <td>{{persona.TIPO_NEGOCIO }}</td>
                        <td class="text-center"><b>{{persona.TRASLADO_PREEXISTENCIA == 1 ? 'Sí' : 'No' }}</b></td>
                        <td class="text-right">
                            {{money(persona.PRIMA_GM, true)}}
                        </td>
                        <td class="text-right">
                        	{{money(persona.PRIMA_AP, true)}}
                        </td>
                        <td class="text-right">
                            {{money(persona.PRIMA_VIDA, true)}}
                        </td>
                        <td class="text-right">
                    		{{money(persona.PRIMA_DENTAL, true)}}
                        </td>
                        <td class="text-right" v-if="false">
                        	{{money(persona.TOTAL_SUMA, true)}}
                        </td>
                        <th class="text-right">
                            {{money(persona.PRIMA_NETA, true)}}
                        </th>
                        <td>
                        	<button type="button" class="btn btn-warning" v-on:click="editPersona(persona)" v-if="disabled!='true'">
	            				<i class="material-icons">edit</i>
	            			</button>
	            			<button type="button" class="btn btn-danger" v-on:click="deletePersona(persona.CODIGO_PERSONA)" v-if="disabled!='true'">
	            				<i class="material-icons">delete</i>
	            			</button>
                        </td>
	                </tr>
	            </tbody>
	            <tfoot>
	            	<tr>
	            		<th colspan="3" class="text-right">
	            			Total
	            		</th>
	            		<td class="text-right">
                            {{totalPrimaGM}}
                        </td>
                        <td class="text-right">
                        	{{totalPrimaAP}}
                        </td>
                        <td class="text-right">
                            {{totalPrimaVIDA}}
                        </td>
                        <td class="text-right">
                    		{{totalPrimaDENTAL}}
                        </td>
                        <td class="text-right" v-if="false">
                        	{{totalSUMA}}
                        </td>
                        <th class="text-right">
                            {{totalPrimaNETA}}
                        </th>
	            		<td>
	            		</td>
	            	</tr>
	            </tfoot>
	        </table>
	    </div>
	    <div v-if="personas.length<=0 && !loading">
	    	<h5 class="text-muted text-center">
	    		No hay registros agregados.
	    	</h5>
	    </div>

    	<div class="modal fade" id="modalPersona" role="dialog" aria-labelledby="modal-oportunidadLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
		  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
		    <div class="modal-content">
		      	<div class="modal-header">
		        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modal=='create'">
		        		Agregar persona
		        	</h5>
		        	<h5 class="modal-title" id="modal-oportunidadLabel" v-if="modal=='edit'">
		        		Editar persona
		        	</h5>
		    	</div>
				<div class="modal-body">
					<div class="mb-3">
						<label>Producto:</label>
						<catalogo-productos v-model="form.producto" :grupo="2">
						</catalogo-productos>
						<div v-if="errors && errors.producto" class="text-danger">
	                        {{ errors.producto[0] }}
	                    </div>
					</div>
					
					<div class="mb-3">
						<label>
							Tipo de Negocio:
						</label>
						<select2 v-model="form.tipoNegocio">
							<option value="Colectivo AGSA">
								Colectivo AGSA
							</option>
							<option value="Individual AGSA">
								Individual AGSA
							</option>
							<option value="Colectivo AGEB">
								Colectivo AGEB
							</option>
						</select2>
						<div v-if="errors && errors.tipo_negocio" class="text-danger">
	                        {{ errors.tipo_negocio[0] }}
	                    </div>
					</div>

					<div class="mb-3">
						<div class="custom-control custom-checkbox">
							<input 
								id="traslado"
								type="checkbox" 
								class="custom-control-input" 
								v-model="form.traslado">
							<label class="custom-control-label" for="traslado">Traslado de preexistencia</label>
						</div>
						<div v-if="errors && errors.traslado" class="text-danger">
	                        {{ errors.traslado[0] }}
	                    </div>
					</div>
					<div class="mb-3">
						Prima de Gastos Médicos cotizada:
						<decimal v-model="form.primaGM"></decimal>
						<div v-if="errors && errors.prima_gm" class="text-danger">
	                        {{ errors.prima_gm[0] }}
	                    </div>
					</div>
					<div class="mb-3">
						Prima de Accidentes Personales cotizada:
						<decimal v-model="form.primaAP"></decimal>
						<div v-if="errors && errors.prima_ap" class="text-danger">
	                        {{ errors.prima_ap[0] }}
	                    </div>
					</div>
					<div class="mb-3">
						Prima de Vida cotizada:
						<decimal v-model="form.primaVIDA"></decimal>
						<div v-if="errors && errors.prima_vida" class="text-danger">
	                        {{ errors.prima_vida[0] }}
	                    </div>
					</div>
					<div class="mb-3">
						Prima de Dental cotizada:
						<decimal v-model="form.primaDENTAL"></decimal>
						<div v-if="errors && errors.prima_dental" class="text-danger">
	                        {{ errors.prima_dental[0] }}
	                    </div>
					</div>
					<div class="mb-3" v-if="false">
						Total Suma Asegurada:
						<decimal v-model="form.sumaAsegurada"></decimal>
					</div>
					<div class="mb-3" v-if="false">
						Prima Neta:
						<decimal v-model="form.primaNETA"></decimal>
						<div v-if="errors && errors.prima_neta" class="text-danger">
	                        {{ errors.prima_neta[0] }}
	                    </div>
					</div>
				</div>

		    	<div class="modal-footer">
		    		<button 
		    			type="button" 
		    			class="btn btn-secondary" 
		    			v-on:click.prevent="validateAndCloseModalPersona"
		    			:disabled="loadingCreate">
		    			Cancelar
		    		</button>
		        	<button 
		        		type="button"
		        		class="btn btn-primary" 
		        		v-on:click.prevent="storePersona"
		        		v-if="modal=='create'"
		        		:disabled="loadingCreate">
		        		Agregar
		        	</button>
		        	<button 
		        		type="button"
		        		class="btn btn-primary" 
		        		v-on:click.prevent="updatePersona"
		        		v-if="modal=='edit'"
		        		:disabled="loadingCreate">
		        		Actualizar
		        	</button>

		    	</div>
		    </div>
		  </div>
		</div>
	</div>
</template>
<script>
	export default {
		props: {
            codigo: String,
            disabled: String,
        },

		mounted(){
			if (this.codigo) {
				this.getPersonas();
			}
		},

		data(){
			return {
				modal: 'create',
				personas: [],
				productos: [],
				loading: false,
				loadingProductos: false,
				loadingCreate: false,
				form: {
					codigo: 0,
					producto: '',
					tipoNegocio: 0,
					traslado: 0,
					primaGM: 0,
					primaAP: 0,
					primaVIDA: 0,
					primaDENTAL: 0,
					primaNETA: 0,
					totalSuma: 0,
				},
				errors: {},
			}
		},

		methods: {
			getPersonas: function(){
				this.loading = true;
				var url = 'api/oportunidades/'+this.oportunidad+'/personas';

				axios.get(url)
				.then(response => {
					this.personas = response.data;
				}).catch(error => {
					console.log(error.response);
				}).then(()=>{
					this.loading = false;
				});
			},

			storePersona: function(){
				this.loadingCreate = true;
				var url = 'api/oportunidades/'+this.oportunidad+'/personas';
				this.errors = {};

				axios.post(url, {
					producto: this.form.producto,
					tipo_negocio: this.form.tipoNegocio,
					traslado: this.form.traslado,
					prima_gm: this.form.primaGM,
					prima_ap: this.form.primaAP,
					prima_vida: this.form.primaVIDA,
					prima_dental: this.form.primaDENTAL,
					prima_neta: this.form.primaNETA,
				})
				.then(response => {
					this.getPersonas();
					this.closeModalPersona();
					this.$toasted.show('El seguro ha sido agregado.');
				}).catch(error => {
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
                    console.log(error.response);
					this.$toasted.show('Error al agregar seguro.');
				}).then(()=>{
					this.loadingCreate = false;
				});
			},

			editPersona: function(data){
				this.form.codigo = data.CODIGO_PERSONA;
				this.form.producto = data.CODIGO_PRODUCTO;
				this.form.tipoNegocio = data.TIPO_NEGOCIO;
				this.form.traslado = data.TRASLADO_PREEXISTENCIA == '1' ? 1 : 0;
				this.form.primaGM = data.PRIMA_GM;
				this.form.primaAP = data.PRIMA_AP;
				this.form.primaVIDA = data.PRIMA_VIDA;
				this.form.primaDENTAL = data.PRIMA_DENTAL;
				this.form.primaNETA = data.PRIMA_NETA;
				this.form.totalSuma = data.TOTAL_SUMA;
				this.modal = 'edit';
				$('#modalPersona').modal('show');
			},

			updatePersona: function(){
				this.loadingCreate = true;
				var url = 'api/oportunidades/personas/'+this.form.codigo;
				this.errors = {};

				axios.put(url, {
					producto: this.form.producto,
					tipo_negocio: this.form.tipoNegocio,
					traslado: this.form.traslado,
					prima_gm: this.form.primaGM,
					prima_ap: this.form.primaAP,
					prima_vida: this.form.primaVIDA,
					prima_dental: this.form.primaDENTAL,
					prima_neta: this.form.primaNETA,
				})
				.then(response => {
					this.getPersonas();
					this.closeModalPersona();
					this.$toasted.show('El seguro ha sido actualizado.');
				}).catch(error => {
					console.log(error.response);
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
					this.$toasted.show('Error al actualizar seguro.');
				}).then(()=>{
					this.loadingCreate = false;
				});
			},

			deletePersona: function(id){
	            var url = 'api/oportunidades/personas/'+ id;

	            axios.delete(url)
	            .then(response => {
	            	this.$toasted.show('Seguro Eliminado');
	                this.getPersonas();
	            }).catch(error => {
	            	console.log(error.response);
	            	this.$toasted.show('Error al eliminar Seguro');
	            });
			},

			openModalPersona: function(){
				$('#modalPersona').modal('show');
				this.cleanFields();
			},

			closeModalPersona: function(){
				$('#modalPersona').modal('hide');
				this.cleanFields();
			},

			validateAndCloseModalPersona: function(){
				var $module = this;

				if (false) {
					$.confirm({
				        title: '¿Estás seguro?',
				        content: '¿Deseas descartar los cambios no guardados?',
				        theme: 'supervan', // 'material', 'bootstrap'
				        buttons: {
				            Confirmar: function () {
				            	$module.closeModalPersona();   
				            },
				            Cancelar: function () {
				            },
				        }
				    });
				}else{
					$module.closeModalPersona();
				}
			},

			cleanFields: function(){
				this.form.producto = '';
				this.form.tipoNegocio = '';
				this.form.traslado = 0;
				this.form.primaGM = 0;
				this.form.primaAP = 0;
				this.form.primaVIDA = 0;
				this.form.primaDENTAL = 0;
				this.form.primaNETA = 0;
				this.form.totalSuma = 0;
				this.form.codigo = 0;
				this.modal = 'create';
				this.errors = {};
			},

			validaFields: function(){
				if (this.form.producto != null && this.form.producto != '') {
					return true;
				}

				if (this.form.cantidad != null && this.form.cantidad > 0) {
					return true;
				}

				if (this.form.precio != null && this.form.precio > 0) {
					return true;
				}

				return false;
			},
		},

		computed: {
            oportunidad: function () {
            	return this.codigo;
            },

            totalPrimaGM: function(){
            	let total = [];
				var $module = this;

				Object.entries(this.personas).forEach(([key, val]) => {
					total.push(val.PRIMA_GM);
				});

				return this.money(total.reduce(function(total, num){
					return parseFloat(total || 0) + parseFloat(num || 0);
				}, 0), true);
            },

			totalPrimaAP: function(){
				let total = [];
				var $module = this;

				Object.entries(this.personas).forEach(([key, val]) => {
					total.push(val.PRIMA_AP);
				});

				return this.money(total.reduce(function(total, num){
					return parseFloat(total || 0) + parseFloat(num || 0);
				}, 0), true);
			},

			totalPrimaVIDA: function(){
				let total = [];
				var $module = this;

				Object.entries(this.personas).forEach(([key, val]) => {
					total.push(val.PRIMA_VIDA);
				});

				return this.money(total.reduce(function(total, num){
					return parseFloat(total || 0) + parseFloat(num || 0);
				}, 0), true);
			},

			totalPrimaDENTAL: function(){
				let total = [];
				var $module = this;

				Object.entries(this.personas).forEach(([key, val]) => {
					total.push(val.PRIMA_DENTAL);
				});

				return this.money(total.reduce(function(total, num){
					return parseFloat(total || 0) + parseFloat(num || 0);
				}, 0), true);
			},

			totalSUMA: function(){
				let total = [];
				var $module = this;

				Object.entries(this.personas).forEach(([key, val]) => {
					total.push(val.TOTAL_SUMA);
				});

				return this.money(total.reduce(function(total, num){
					return parseFloat(total || 0) + parseFloat(num || 0);
				}, 0), true);
			},

			totalPrimaNETA: function(){
				let total = [];
				var $module = this;

				Object.entries(this.personas).forEach(([key, val]) => {
					total.push(val.PRIMA_NETA);
				});

				return this.money(total.reduce(function(total, num){
					return parseFloat(total || 0) + parseFloat(num || 0);
				}, 0), true);
			},
        },

        watch: {
    		'form.producto': function (val) {
      			var $productos = this.productos.filter(function(value){
      				return value.CODIGO_PRODUCTO == val;
      			});

  				if ($productos.length > 0) {
      				this.form.precio = $productos[0].PRECIO ? $productos[0].PRECIO : 0;
      			}else{
      				this.form.precio = 0;
      			}
    		}
  		}
	}
</script>